import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

export default class AlertDialog extends Component {
  constructor(props){
      super(props);

      this.state = {
          open: false
      }
  }

  handleClose = () => {
    this.setState({open: false});
  }

  render(){
    return (
        <Dialog
            open={this.props.open}
            onClose={this.handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">{this.props.title}</DialogTitle>
            <DialogContent>
            <DialogContentText id="alert-dialog-description">
                {this.props.body}
            </DialogContentText>
            </DialogContent>
            <DialogActions>
            <Button onClick={this.props.handleNo} color="primary">
                خیر
            </Button>
            <Button onClick={this.props.handleYes} color="primary" autoFocus>
                بله
            </Button>
            </DialogActions>
        </Dialog>
    )
  };
}
